import { render, staticRenderFns } from "./DynamicItems.vue?vue&type=template&id=10e013ea&scoped=true&lang=pug&"
import script from "./DynamicItems.vue?vue&type=script&lang=js&"
export * from "./DynamicItems.vue?vue&type=script&lang=js&"
import style0 from "./DynamicItems.vue?vue&type=style&index=0&id=10e013ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e013ea",
  null
  
)

export default component.exports